const { createSelector } = require('reselect')
const selectFavourites = state => state['marketplace.favourites'].getFavorites

const getFavourites = () => createSelector(
  [selectFavourites],
  prof => prof.data,
)

const getFavouritesError = () => createSelector(
  [selectFavourites],
  prof => prof.error,
)

const getFavouritesLoading = () => createSelector(
  [selectFavourites],
  prof => prof.loading,
)

const selectFavouritesUpdate = state => state['marketplace.favourites'].updateFavorites

const updateFavourites = () => createSelector(
  [selectFavouritesUpdate],
  upd => upd.data,
)

const updateFavouritesError = () => createSelector(
  [selectFavouritesUpdate],
  upd => upd.error,
)

const updateFavouritesLoading = () => createSelector(
  [selectFavouritesUpdate],
  upd => upd.loading,
)

module.exports = {
  getFavourites,
  getFavouritesError,
  getFavouritesLoading,
  updateFavourites,
  updateFavouritesError,
  updateFavouritesLoading
}
